import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

const MyArrow = ({ color }) => {
  return (
    <svg
      width='40'
      height='24'
      viewBox='0 0 40 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.84058 10.5C1.01215 10.5 0.340576 11.1716 0.340576 12C0.340576 12.8284 1.01215 13.5 1.84058 13.5V10.5ZM39.2584 13.0607C39.8442 12.4749 39.8442 11.5251 39.2584 10.9394L29.7125 1.39341C29.1267 0.807627 28.1769 0.807627 27.5911 1.39341C27.0053 1.9792 27.0053 2.92895 27.5911 3.51473L36.0764 12L27.5911 20.4853C27.0053 21.0711 27.0053 22.0208 27.5911 22.6066C28.1769 23.1924 29.1267 23.1924 29.7125 22.6066L39.2584 13.0607ZM1.84058 13.5H38.1977V10.5H1.84058V13.5Z'
        fill={color ? color : 'black'}
      />
    </svg>
  );
};

const StyledButton = styled.button`
  border: 2px solid
    ${({ color, theme }) =>
      color !== undefined ? color : theme.colors.primary};
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  border-radius: ${({ rounded }) => (rounded ? '8px' : null)};
  background: none;

  ${({ arrow }) =>
    arrow &&
    ` 
  svg {
    opacity: 0;
    margin-left: 6px;
    transform: translateX(-48px);
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
    filter: drop-shadow( 0 0 5px rgba(0, 0, 0, .75));
  }

  :hover {
    a {
      transform: translateX(0);
    }
    svg {
      transform: translateX(0px);
      opacity: 1;
    }
  }
  `}
`;

const StyledLink = styled(Link)`
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.75);
  width: auto;
  display: flex;
  padding: 20px;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.textFont};
  font-size: 30px;
  line-height: 30px;
  color: ${({ color, theme }) =>
    color !== undefined ? color : theme.colors.primary};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  ${({ arrow }) =>
    arrow &&
    `
  transition: transform 0.3s ease-in-out;
  transform: translateX(24px);
  `}
`;

const Button = ({ children, link, ...props }) => {
  return (
    <StyledButton {...props}>
      <StyledLink to={link} {...props}>
        {children}
        {props.arrow && <MyArrow color={props.color} />}
      </StyledLink>
    </StyledButton>
  );
};

export default Button;
